<template>
    <div class="d-flex gap-2" style="min-width: 400px">
        <v-select label="Month" v-model="selectedOption" :items="['Month', 'Date Range']" required>
            <template v-slot:prepend-inner>
                <i class="ti ti-refresh"></i>
            </template>
        </v-select>
        <div v-if="selectedOption == 'Month'" style="min-width: 150px">
            <v-select label="Select Month" v-model="selectedMonth" :items="months" hide-details required>
                <template v-slot:prepend-inner>
                    <i class="ti ti-calendar-month"></i>
                </template>
            </v-select>
        </div>
        <div v-else style="min-width: 220px">
            <!--<v-date-picker rounded="sm" color="blue" v-model="selectedDate" is-range>
        <template #default="{ togglePopover }">
            <v-text-field variant="outlined" v-model="formattedDate" label="Date Range" @click="togglePopover" hide-details required>
                <template v-slot:prepend-inner>
                    <i class="ti ti-arrows-right-left"></i>
                </template>
            </v-text-field>
        </template>
    </v-date-picker>-->
            <!--<v-date-input :label="label"
                  prepend-icon=""
                  v-model="selectedDate"
                  :value="displayDate"
                  hide-actions
                  placeholder="Select Date"
                  multiple="range"
                  @update:modelValue="update"></v-date-input>-->
            <VueDatePicker
                v-model="selectedDate"
                range
                position="left"
                teleport
                auto-apply
                :format="formatDate"
                :enableTimePicker="false"
            />
        </div>
    </div>
</template>

<script>
    import { VDateInput } from 'vuetify/labs/VDateInput'
    import { format, parse } from 'date-fns'
    export default {
        components: {
            VDateInput,
        },
        props: {
            modelValue: String,
            label: {
                type: String,
                default: 'Date',
            },
            hideDetails: {
                type: Boolean,
                default: false,
            },
            lg: {
                type: String,
                default: '12',
            },
        },
        created() {
            var currentDate = new Date()
            var month = currentDate.getMonth()
            this.selectedMonth = this.months[month]
        },
        data() {
            return {
                selectedOption: 'Month',
                selectedMonth: null,
                selectedDate: null,
                displayDate: null,
                months: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                    'This Year',
                ],
            }
        },
        methods: {
            update(dates) {
                var length = dates.length
                if (length > 0) {
                    var fromDate = format(dates[0], 'dd-MM-yyyy')
                    var toDate = format(dates[length - 1], 'dd-MM-yyyy')
                    var fromDate2 = format(dates[0], 'yyyy-MM-dd')
                    var toDate2 = format(dates[length - 1], 'yyyy-MM-dd')
                    this.displayDate = `${fromDate} to ${toDate}`
                    this.$emit('update:modelValue', `${fromDate2},${toDate2}`)
                }
            },
            formatDate(date) {
                const from = format(date[0], 'yyyy-MM-dd')
                const to = format(date[1], 'yyyy-MM-dd')
                const dateRange = `${from},${to}`
                this.$emit('update:modelValue', dateRange)
                return `${format(date[0], 'dd-MM-yyyy')} to ${format(date[1], 'dd-MM-yyyy')}`
            },
        },
        watch: {
            selectedMonth(n, o) {
                var currentDate = new Date()
                var month = this.months.indexOf(n)
                var year = currentDate.getFullYear()
                var start_month
                var start_year
                if (month == 12) {
                    var start = new Date(year, 1, 1)
                    var end = new Date(year, 12, 31)
                    var value = format(start, 'yyyy-MM-dd') + ',' + format(end, 'yyyy-MM-dd')
                    this.$emit('update:modelValue', value)
                    this.selectedDate.start = start
                    this.selectedDate.end = end
                } else {
                    if (month == 0) {
                        start_month = 11
                        start_year = year - 1
                    } else {
                        start_month = month - 1
                        start_year = year
                    }
                    var start = new Date(start_year, start_month, 27)
                    var end = new Date(year, month, 26)
                    var value = format(start, 'yyyy-MM-dd') + ',' + format(end, 'yyyy-MM-dd')
                    this.$emit('update:modelValue', value)
                    this.selectedDate.start = start
                    this.selectedDate.end = end
                }
            },
        },
    }
</script>
